/**
 * Login
 * @author omriha
 * 15/10/2019
 */

 import React, {useEffect} from 'react';
 import './Login.css';
 
 import LoginLogoSection from './LoginLogoSection';
 import LoginLogicSection from './LoginLogicSection';
 import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
 import SMCLink from '../../components/Simple/SMCLink';
 import i18n from '../../i18n';
 import RowLayout from '../../components/Layouts/RowLayout';
 import {useTranslation} from 'react-i18next';
 import clsx from 'clsx';
 import {useSnackbar} from 'notistack';
 import {changeI18nLanguage} from '../../i18n/utils';
 
 /**
  * Main login page component
  */
 function Login() {
     const { closeSnackbar } = useSnackbar();
     useTranslation(); // Use translation to force re-rendering on language change
     const currentLanguge = i18n.language;
 
     // Close all snackbars on loading of login page
     useEffect(() => {
         closeSnackbar();
     }, [closeSnackbar]);
 
     return (
         <div className="loginRoot">
             <div className="center centerContent loginMainComponent">
                 <div className="loginLogoSection">
                     <LoginLogoSection />
                 </div>
                 <div className="loginLogicSection">
                     <LoginLogicSection />
                 </div>
             </div>
             <RowLayout center height={50} spacing="4px" className="loginFooter">
                 <span className="loginCredit">©2022 Check Point Software Technologies Ltd. All rights reserved.</span>
                 <RowLayout spacing="4px" className="loginCredit">
                     <FontAwesomeIcon icon="globe-americas" />
                     <SMCLink className={clsx('langLinks', currentLanguge === 'en' && 'selectedLang')} onClick={() => changeI18nLanguage ('en')}>
                         English
                     </SMCLink>
                     |
                     <SMCLink className={clsx('langLinks', currentLanguge === 'ja' && 'selectedLang')} onClick={() => changeI18nLanguage ('ja')}>
                         日本語
                     </SMCLink>
                     |
                     <SMCLink className={clsx('langLinks', currentLanguge === 'fr' && 'selectedLang')} onClick={() => changeI18nLanguage ('fr')}>
                         Français
                     </SMCLink>
                     |
                     <SMCLink className={clsx('langLinks', currentLanguge === 'de' && 'selectedLang')} onClick={() => changeI18nLanguage ('de')}>
                         Deutsch
                     </SMCLink>
                 </RowLayout>
             </RowLayout>
         </div>
     );
 }
 
 export default Login;